import React, { useEffect, useState } from "react";
import {
  fetchServiceAndTaxSettings,
  saveServiceAndTaxSettingsAndSessions,
} from "../../../../services/Settings/ServicesandTaxSettingsAndSessios/ServicesAndTaxApi";
import {
  Box,
  Typography,
  Paper,
  CircularProgress,
  Button,
  Switch,
  FormControlLabel,
  useTheme,
  Stack,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";

const TaghezPrintSettingTap = () => {
  const theme = useTheme();
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState({});
  const [successMsg, setSuccessMsg] = useState("");
  const [ctrlPPrint, setCtrlPPrint] = useState(true);
  const [autoPreparationPrint, setAutoPreparationPrint] = useState(true);

  useEffect(() => {
    const loadSettings = async () => {
      setLoading(true);
      try {
        const res = await fetchServiceAndTaxSettings();
        const s = res || {};
        setSettings(s);
        setCtrlPPrint(Number(s.ctrl_p_print) === 1);
        setAutoPreparationPrint(Number(s.auto_preparation_print) === 1);
      } catch (error) {
        setSettings({});
        setCtrlPPrint(true);
        setAutoPreparationPrint(true);
      } finally {
        setLoading(false);
      }
    };
    loadSettings();
  }, []);

  const handleSave = async () => {
    try {
      await saveServiceAndTaxSettingsAndSessions({
        ...settings,
        ctrl_p_print: ctrlPPrint ? 1 : 0,
        auto_preparation_print: autoPreparationPrint ? 1 : 0,
      });
      setSuccessMsg("✅ تم تحديث البيانات بنجاح!");
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch {
      setSuccessMsg("❌ فشل في تحديث البيانات.");
      setTimeout(() => setSuccessMsg(""), 3000);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200 }}>
        <CircularProgress size={40} />
      </Box>
    );
  }

  return (
    <Paper
      elevation={8}
      sx={{
        p: { xs: 2, sm: 4 },
        mt: 3,
        borderRadius: 5,
        background:
          theme.palette.mode === "dark"
            ? "linear-gradient(135deg, #23272f 0%, #1a1a1a 100%)"
            : "linear-gradient(135deg, #e3f2fd 0%, #f5f5f5 100%)",
        boxShadow: "0 8px 32px rgba(33,150,243,0.12)",
        maxWidth: 440,
        mx: "auto",
      }}
    >
      <Box sx={{ textAlign: "center", mb: 3 }}>
        <PrintIcon sx={{ fontSize: 48, color: theme.palette.primary.main, mb: 1 }} />
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            color: theme.palette.mode === "dark" ? "#90caf9" : "#1976d2",
            letterSpacing: 1,
            mb: 1,
          }}
        >
          إعدادات طابعة التجهيز
        </Typography>
        <Typography sx={{ color: theme.palette.text.secondary, fontSize: "1rem" }}>
          تحكم في خيارات الطباعة الخاصة بالتجهيز بسهولة واحترافية.
        </Typography>
      </Box>
      <Stack spacing={3} sx={{ mb: 2 }}>
        
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            px: 2,
            py: 2,
            borderRadius: 3,
            background: theme.palette.mode === "dark" ? "#23272f" : "#f0f7fa",
            boxShadow: "0 2px 8px rgba(33,150,243,0.08)",
          }}
        >
          <AutoAwesomeMotionIcon sx={{ color: "#ff9800", fontSize: 30 }} />
          <FormControlLabel
            control={
              <Switch
                checked={autoPreparationPrint}
                onChange={(e) => setAutoPreparationPrint(e.target.checked)}
                color="primary"
                sx={{
                  "& .MuiSwitch-thumb": {
                    bgcolor: theme.palette.mode === "dark" ? "#90caf9" : "#1976d2",
                  },
                  "& .MuiSwitch-track": {
                    bgcolor: theme.palette.mode === "dark" ? "#23272f" : "#90caf9",
                  },
                }}
              />
            }
            label={
              <Typography sx={{ fontWeight: "bold", color: "#ff9800" }}>
                طباعة تلقائية عند التجهيز
              </Typography>
            }
            sx={{ m: 0 }}
          />
        </Box>
      </Stack>
      <Button
        variant="contained"
        color="primary"
        onClick={handleSave}
        sx={{
          mt: 2,
          fontWeight: "bold",
          borderRadius: 3,
          boxShadow: "0 2px 8px rgba(33,150,243,0.12)",
          py: 1.2,
          fontSize: "1rem",
          letterSpacing: 1,
          width: "100%",
        }}
      >
        حفظ التعديلات
      </Button>
      {successMsg && (
        <Typography
          sx={{
            mt: 2,
            textAlign: "center",
            fontWeight: "bold",
            color: successMsg.startsWith("✅") ? "#388e3c" : "#d32f2f",
            background: theme.palette.mode === "dark" ? "#23272f" : "#f5f5f5",
            borderRadius: 2,
            py: 1,
          }}
        >
          {successMsg}
        </Typography>
      )}
    </Paper>
  );
};

export default TaghezPrintSettingTap;
